import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { PrivilegedIdSettingState, PrivilegedIdSetting } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';
import { AppContext } from '../../context';
const MessageKey = AppContext.MessageKey;
import { translator } from '../../translator';

export const actions: ActionTree<PrivilegedIdSettingState, RootState> = {
    /**
     * 特権ID管理情報取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {string} category 絞り込むカテゴリ名
     * @returns {Promise<void>}
     */
    async show({ dispatch, commit }, category: string = '') {
        const requestParams = category ? { category } : undefined;
        try {
            commit(types.SHOW_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.PrivilegedIdSetting.SHOW,
                    params: { ...requestParams },
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SHOW_SUCCESS, { privilegedIdSetting: resData });
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SHOW_FAILURE, resData.errors[0]);
        }
    },

    /**
     * 特権ID管理情報更新
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} rootState Vuex変数
     * @param {PrivilegedIdSetting} setting 更新する特権ID管理情報
     * @param {string} successMessage 成功時に表示するメッセージ
     * @returns {Promise<void>}
     */
    async update(
        { dispatch, commit, rootState },
        {
            setting,
            successMessage,
            category,
        }: { setting: PrivilegedIdSetting; successMessage: string; category: string }
    ) {
        try {
            commit(types.UPDATE_START, category);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'put',
                    url: ApiUrl.PrivilegedIdSetting.UPDATE,
                    params: setting,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.UPDATE_SUCCESS);

                // 成功トースト表示
                dispatch('toastMessage', successMessage, { root: true });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.UPDATE_FAILURE, params);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ALL);
    },
};
